export const websiteBackOffice = {
  orderManagement: [
    {
      label: "View Detail",
      value: "view",
    },
   
    {
      label: "Edit Status",
      value: "edit",
    },
  ],
  specialRequest: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Approve Order",
      value: "edit",
    },
  ],
  promotionSetting: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create Promotion",
      value: "create",
    },
    {
      label: "Edit Promotion",
      value: "edit",
    },
    {
      label: "Delete Promotion",
      value: "delete",
    },
  ],
  discountCo: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create Discount",
      value: "create",
    },
    {
      label: "Edit Discount",
      value: "edit",
    },
    {
      label: "Delete Discount",
      value: "delete",
    },
  ],
  priceListX10: [
    { label: "View Price List", value: "view" },
    {
      label: "Create Price List",
      value: "create",
    },
    {
      label: "Edit Price List",
      value: "edit",
    },
    {
      label: "Delete Price List",
      value: "delete",
    },
  ],
  saleManagement: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create User",
      value: "create",
    },
    {
      label: "Edit User",
      value: "edit",
    },
    {
      label: "Delete User",
      value: "delete",
    },
  ],
  roleManagement: [
    {
      label: "View Role",
      value: "view",
    },
    {
      label: "Create Role",
      value: "create",
    },
    {
      label: "Edit Role",
      value: "edit",
    },
    {
      label: "Delete Role",
      value: "delete",
    },
  ],
  productManagement: [
    {
      label: "View Product",
      value: "view",
    },
    {
      label: "Edit Product",
      value: "edit",
    },
  ],
};
export const saleCodaSale = {
  createOrder: [
    {
      label: "Create Order Item",
      value: "createOrderItem",
    },
    {
      label: "View Item",
      value: "viewItem",
    },
  ],
  history: [
    {
      label: "View History",
      value: "viewHistory",
    },
  ],
  feature: [
    {
      label: "Confirm Order",
      value: "confirmOrder",
    },
    {
      label: "Cancel Order",
      value: "cancelOrder",
    },
  ],
  notification: [
    {
      label: "View Notification",
      value: "viewNotification",
    },
  ],
  profile: [
    {
      label: "Manage Profile",
      value: "manageProfile",
    },
  ],
};

export const saleCodaShop = {
  order: [
    {
      label: "Create Order",
      value: "createOrder",
    },
    {
      label: "Manage Order",
      value: "manageOrder",
    },
  ],
};
